module.exports = __webpack_public_path__ + "img/shuffle.9033c823.svg";